import { ReactNode } from "react";
import { useTheme } from "styled-components";
import { ModalClose } from "./ModalClose";
import { useModalContext } from "./ModalContext";
import { ModalTitle } from "./ModalTitle";

export type IModalHeaderProps = {
  children: ReactNode;
};

export enum ModalHeaderTestIds {
  "MODAL_HEADER" = "MODAL_HEADER",
}

export const ModalHeader = (props: IModalHeaderProps) => {
  const { children } = props;

  const { handleClose } = useModalContext();

  const theme = useTheme();

  return (
    <header
      // Sticky on phones so the title and close button stay reachable while
      // a long form scrolls underneath.
      className="flex items-start gap-3 py-4 flex-shrink-0 font-medium border-b max-md:sticky max-md:top-0 max-md:z-10"
      data-testid={ModalHeaderTestIds.MODAL_HEADER}
      style={{
        backgroundColor: theme.modalBackgroundColor,
        borderColor: theme.borderColor,
        paddingLeft: theme.gutter,
        paddingRight: theme.gutter,
      }}
    >
      <ModalTitle>{children}</ModalTitle>

      <div className="ml-auto flex-shrink-0 pt-0.5">
        <ModalClose onClick={() => handleClose && handleClose()} />
      </div>
    </header>
  );
};
